import { render, staticRenderFns } from "./CardDataEdit.vue?vue&type=template&id=13090580&"
import script from "./CardDataEdit.vue?vue&type=script&lang=js&"
export * from "./CardDataEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports